import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MarketPartner {
  id: string;
  slug: string;
  category_slug: string;
  category_title: string;
  brand_name: string;
  logo_url: string | null;
  short_description: string;
  // affiliate_url intentionally omitted — never exposed to UI
  is_active: boolean;
  featured: boolean;
  sort_order: number;
}

export function useMarketPartners() {
  return useQuery({
    queryKey: ['market-partners'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('market_partners')
        .select('id, slug, category_slug, category_title, brand_name, logo_url, short_description, is_active, featured, sort_order')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

      if (error) throw error;
      return (data ?? []) as MarketPartner[];
    },
    staleTime: 1000 * 60 * 5, // 5 min cache
  });
}
